import React from 'react';
import './ActionSection.css';
import { Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ActionSection = () => {
  const navigate = useNavigate();
  const handleRegister = () => {
    console.log('Register for Free Trial');
    navigate('/auth');
  };
  
  const handleLogin = () => {
    console.log('Login');
    navigate('/auth?skipRegistration=true');
  };

  return (
    <div className="action-section">
      <div className="action-content">
        <Typography variant="h4" className="action-title">
          Are you ready to explore the benefits of using AIM?
        </Typography>
        <Typography variant="h6" className="action-subtitle">
           Register now and get your free trial!
        </Typography>
      </div>
      <div className="action-buttons">
        <Button
          variant="contained"
          color="primary"
          className="primary-button"
          onClick={handleRegister}
        >
          Register Now for Free Trial
        </Button>
        <Button
          className="login-button"
          onClick={handleLogin}
        >
          Already a Member? Login
        </Button>
      </div>
    </div>
  );
};

export default ActionSection;
